<template>
  <div class="banquets-tabs">
    <div class="ui top attached tabular menu">
      <a class="active item" data-tab="banquets">
        フォーム予約
        <span class="ui red label" v-if="banquetRequiredCount > 0">{{ banquetRequiredCount }}</span>
      </a>
      <a class="item" data-tab="direct-calls">
        電話予約
        <span class="ui red label" v-if="directCallsRequiredCount > 0">{{ directCallsRequiredCount }}</span>
      </a>
    </div>

    <div class="ui bottom attached active tab segment" data-tab="banquets">
      <shopadmin-banquets></shopadmin-banquets>
    </div>
    <div class="ui bottom attached tab segment" data-tab="direct-calls">
      <shopadmin-direct-calls></shopadmin-direct-calls>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banquets-tabs',
  components: {
    'shopadmin-banquets': () => import('./banquets/index.vue'),
    'shopadmin-direct-calls': () => import('./directCalls.vue')
  },
  data() {
    return {
      banquetRequiredCount: 0,
      directCallsRequiredCount: 0,
    };
  },
  created: function() {
    this.createForm().get('/shopadmin/api/banquets/required_count', function(response) {
      this.banquetRequiredCount = response.data.required_count;
    }.bind(this));
    this.createForm().get('/shopadmin/api/direct_calls/required_count', function(response) {
      this.directCallsRequiredCount = response.data.required_count;
    }.bind(this));
  },
  mounted: function() {
    $('.menu .item').tab();
  },
};
</script>